<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-select v-model="search.chainProjectId" placeholder="请选择项目名称" clearable>
                <el-option
                v-for="item in optionsProject"
                :key="item.chainProjectId"
                :label="item.chainProjectName"
                :value="item.chainProjectId">
                </el-option>
            </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">打包块编号：</span>
        <el-input v-model="search.packBlockNumber" :size="size" clearable placeholder="请输入打包块编号"></el-input>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
        <!-- <el-button icon="el-icon-upload2" v-if="showButton('export')" @click="exportBigData">导出Excel</el-button> -->
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="packBlockNumber" label="打包块编号" align="center" width="150"></el-table-column>
        <el-table-column prop="chainProjectName" label="项目名称" align="center" ></el-table-column>
        <el-table-column prop="" label="尺寸" align="center" >
          <template #default="scope">
            {{scope.row.chainLength}}*{{scope.row.chainWidth}}*{{scope.row.chainThickness}}
          </template>
        </el-table-column>
        <el-table-column prop="personCharge" label="负责人" align="center" ></el-table-column>
        <el-table-column prop="packTime" label="打包时间" align="center" ></el-table-column>
        <el-table-column label="操作" align="center" width="280">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="printProp(row)">打印</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle? '新增打包' :'修改打包'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="45%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <!-- <el-form-item label="打包块编号：" prop="packBlockNumber">
          <el-input v-model="ruleForm.packBlockNumber" :size="size" clearable placeholder="请输入打包块编号" ></el-input>
        </el-form-item> -->
        <el-form-item label="项目名称：" prop="chainProjectId">
         <el-select v-model="ruleForm.chainProjectId" placeholder="请选择项目名称" clearable @change="projectChange">
                <el-option
                v-for="item in optionsProject"
                :key="item.chainProjectId"
                :label="item.chainProjectName"
                :value="item.chainProjectId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="尺寸：" prop="size">
          <el-input v-model="ruleForm.size" :size="size" disabled  placeholder="请输入尺寸" ></el-input>
        </el-form-item>
        <el-form-item label="强度：" prop="strength">
          <el-input v-model="ruleForm.strength" :size="size" disabled  placeholder="请输入强度" ></el-input>
        </el-form-item>
        <el-form-item label="打包时间：" prop="packTime">
            <el-date-picker
                v-model="ruleForm.packTime"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
                placeholder="请选择开始日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="负责人：" prop="personCharge">
          <el-input v-model="ruleForm.personCharge" :size="size" clearable  placeholder="请输入负责人" ></el-input>
        </el-form-item>
        <el-form-item label="打包数量：" prop="packCount" v-if="asyncTitle">
          <el-input-number v-model="ruleForm.packCount"  :min="1" :max="99" ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
    <div v-show="showAbtn">
      <a id="segmentPrint" :href="`printpipe://7,${trayNums}`"><p></p></a>
    </div>
    <!-- 二维码打印弹框 -->
    <el-dialog
      class="prop_dialog"
      title="托盘二维码"
      :close-on-click-modal="false"
      :visible.sync="qrDialogVisible"
      width="400px">
      <div id="qr-print-area" class="qr-print-area">
        <div class="qr-title"></div>
        <div id="qr-code-container" class="qr-code-container"></div>
        <!-- <div class="qr-number">{{ currentTrayNumber }}</div> -->
      </div>
      <div slot="footer">
        <el-button @click="qrDialogVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="printQrCode">打 印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize, downFiles } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        showAbtn: false, // 打印按钮是否显示
        trayNums: null, // 打印的托盘编号
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //托盘信息列表
        optionsTray: [], //托盘名称
        rowIds: null, //选中的行id
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
            packBlockNumber: '',
            packCount:'1',
            // trayId: [],
            packTime: '',
        }, // 按钮表单
        rules: {
          packBlockNumber: [{
            required: true,
            message: '请输入打包块编号',
            trigger: 'blur'
          }],
          chainProjectId: [{
            required: true,
            message: '请选择项目',
            trigger: 'change'
          }],
          packCount: [{
            required: true,
            message: '请输入打包数量',
            trigger: 'blur'
          }],
          personCharge: [{
            required: true,
            message: '请输入负责人',
            trigger: 'blur'
          }],
          packTime: [{
            required: true,
            message: '请选择打包时间',
            trigger: 'change'
          }],
        },
        qrDialogVisible: false,
        currentTrayNumber: '',
        qrScriptLoaded: false,
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {
            packBlockNumber: '',
            // trayId: [],
            packTime: '',
          };
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes();
      that.getAllProject();
    },
    methods: {
      
      // 打印按钮信息
      printProp(val) {
        this.trayNums = val.chainPackId;
        this.$nextTick(()=>{
            document.getElementById("segmentPrint").click();
        })
        // this.currentTrayNumber = val.trayNumber;
        // this.qrDialogVisible = true;
        // this.$nextTick(() => {
        //   this.loadQrScript().then(() => {
        //     this.generateQrCode(val.trayNumber);
        //   });
        // });
      },
      // 加载二维码脚本
      loadQrScript() {
        return new Promise((resolve, reject) => {
          if (this.qrScriptLoaded) {
            resolve();
            return;
          }
          if (window.QRCode) {
            this.qrScriptLoaded = true;
            resolve();
            return;
          }
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = 'https://cdn.jsdelivr.net/npm/qrcodejs2@0.0.2/qrcode.js';
          script.onload = () => {
            this.qrScriptLoaded = true;
            resolve();
          };
          script.onerror = () => {
            reject(new Error('二维码脚本加载失败'));
            this.$message.error('二维码脚本加载失败');
          };
          document.head.appendChild(script);
        });
      },
      // 生成二维码
      generateQrCode(text) {
        const container = document.getElementById('qr-code-container');
        if (!container) return;
        container.innerHTML = '';
        new window.QRCode(container, {
          text: text,
          width: 220,
          height: 220,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: window.QRCode.CorrectLevel.H
        });
      },
    
    //获取所有项目信息
      getAllProject(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
        }
        this.$api.Chain.searchChainProjectList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.optionsProject = res.data.list;
          }
        })
      },
      // 选择项目带出尺寸和强度
      projectChange(val) {
        const item = this.optionsProject.find(i => i.chainProjectId === val);
        if (item) {
          this.$set(this.ruleForm, 'size', `${item.chainLength}*${item.chainWidth}*${item.chainThickness}`);
          this.$set(this.ruleForm, 'strength', item.concreteGrade);
        } else {
          this.$set(this.ruleForm, 'size', '');
          this.$set(this.ruleForm, 'strength', '');
        }
      },
     getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
        }
        this.loading = true;
        this.$api.Tray.searchTrayList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.optionsTray = res.data.list;
          }
        })
      },
      
    // 转圈圈
    functionLoading() {
        this.loadingView = this.$loading({
            lock: true,
            text: '请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    //导出Excel
    exportBigData(){
        this.functionLoading();
        let params  = Object.assign({},this.search)
        this.$api.Tray.exportTrayDatas(params).then(res => {
            downFiles(res, '托盘信息', 'xls')
            this.loadingView.close()
        })
        .catch(() => {
          this.loadingView.close();
        })
    },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Dists.searchDistList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.rowIds = row.chainPackId;
        this.ruleForm = row;
        this.$set(this.ruleForm, 'size', `${row.chainLength}*${row.chainWidth}*${row.chainThickness}`);
        this.projectChange(row.chainProjectId);
        // this.$api.Dists.detailsDistDevice({chainPackId: row.chainPackId}).then(res=>{
        //     if(res.statusMsg === 'ok'){
        //         this.ruleForm = res.data
        //     }else{
        //         this.$message.warning(res.statusMsg)
        //     }
        // })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Dists.deleteDistDevice({chainPackId: row.chainPackId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            // console.log(params,'params')
            // return
            // params.trayId = this.ruleForm.trayId.join(',')
            this.$api.Dists.insertDistOrUpdate(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm,{
              chainPackId: this.rowIds
            });
            // params.trayId = this.ruleForm.trayId.join(',')
            this.$api.Dists.insertDistOrUpdate(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';

.qr-print-area {
  text-align: center;
  padding: 20px 10px;
}

.qr-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #333;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  min-height: 220px;

  ::v-deep canvas,
  ::v-deep img {
    width: 220px !important;
    height: 220px !important;
  }
}

.qr-number {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  word-break: break-all;
}
</style>